var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73999 6.54055L13.24 1.31055",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0901 0.5L13.2401 1.31L12.4401 3.46",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13.5098H11.25V6.50977C11.25 6.37716 11.3027 6.24998 11.3964 6.15621C11.4902 6.06244 11.6174 6.00977 11.75 6.00977H13.25C13.3826 6.00977 13.5098 6.06244 13.6036 6.15621C13.6973 6.24998 13.75 6.37716 13.75 6.50977V13.5098Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.5098H6.25L6.25 8.00977C6.25 7.87716 6.30268 7.74998 6.39645 7.65621C6.49021 7.56244 6.61739 7.50977 6.75 7.50977H8.25C8.38261 7.50977 8.50979 7.56244 8.60355 7.65621C8.69732 7.74998 8.75 7.87716 8.75 8.00977V13.5098Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.5098H1.25L1.25 9.50977C1.25 9.37716 1.30268 9.24998 1.39645 9.15621C1.49021 9.06244 1.61739 9.00977 1.75 9.00977H3.25C3.38261 9.00977 3.50979 9.06244 3.60355 9.15621C3.69732 9.24998 3.75 9.37716 3.75 9.50977L3.75 13.5098Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.268ed16c2133709a52a5bedc0fdc7e1a.svg";
export { ForwardRef as ReactComponent };